import React, { useEffect } from 'react';

import { Pagination, Spin, Empty } from 'antd';

import useStore from 'store/marketing-activities/apply-list';

import ListItem from './ListItem';


type Iprops = {

}

const SPTable:React.FC<Iprops> = (props) => {

  const { fetchList, loadingList, searchData, searchList, total } = useStore(state => ({ ...state }));

  const handlePageSizeChange = (page: number, page_size: number) => {
    fetchList({ ...searchData, page, page_size });
  }
 
  useEffect(() => {
    fetchList(searchData);
  }, []);

  return (
    <Spin spinning={loadingList}>
      {(searchList || []).length ? <div style={{  marginTop: 20, minHeight: 200, display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
        {(searchList || []).map((item: any) => {
          return <ListItem data={item} key={item.action_code} />
        })}
      </div> : <Empty style={{ marginTop: 100 }} />}
      <Pagination
        showQuickJumper
        showSizeChanger
        style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end' }}
        current={searchData?.page || 1}
        pageSize={searchData?.page_size || 9}
        showTotal={total => `共 ${total} 条数据`}
        pageSizeOptions={[9, 18, 45, 90]}
        total={total} onChange={handlePageSizeChange}
      />
    </Spin>
  )
}

export default SPTable;